import { render, staticRenderFns } from "./BatchRecoverDialog.vue?vue&type=template&id=765fb1c1&scoped=true&"
import script from "./BatchRecoverDialog.vue?vue&type=script&lang=js&"
export * from "./BatchRecoverDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765fb1c1",
  null
  
)

export default component.exports